import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all colours
export const getColours = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/colours`);
    return response.data;
  } catch (error) {
    console.error("Error fetching colours", error.response?.data || error);
    throw error;
  }
};

// GET a single colour
export const getColoursById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/colours/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching colours:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new colour
export const createColours = async (coloursData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/colours`, coloursData);
    return response.data;
  } catch (error) {
    console.error("Error creating colours:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing colour
export const updateColours = async (id, coloursData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/colours/${id}`, coloursData);
    return response.data;
  } catch (error) {
    console.error("Error updating colours:", error.response?.data || error);
    throw error;
  }
};

// DELETE a colours
export const deleteColours = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/colours/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting colours:", error.response?.data || error);
    throw error;
  }
};
